import ReactGA from "react-ga4";

export const googleAnalytics = {
    initGA,
    sendLogEvents,
}

function initGA(){
    if(document._portalConfig.isTrackingGGAds && document._portalConfig.measurementGAId){
        ReactGA.initialize(document._portalConfig.measurementGAId);      
        console.log("gg ads init ===", document._portalConfig.measurementGAId);  
    }
}

async function sendLogEvents(eventName, data){
    if(document._portalConfig.isTrackingGGAds && document._portalConfig.measurementGAId){
        console.log("gg ads eventName ===", eventName);
        console.log("gg ads data ===", data);
        ReactGA.event(eventName, data);
    }
}


export const eventTypeSimple = {
    add_to_cart: "add_to_cart",
    sign_up: "sign_up",
    //custom event
    order_checkout: 'order_checkout',
    purchase: 'purchase',
    find_location: 'find_location',
    viewed_offer: 'viewed_offer',
}
